import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllCompanies ({ commit }) {
    api.getCompanies(companies => {
      commit('setCompanies', companies)
    })
  },
  updateCompany (context, company) {
    api.updateCompany(company, function () {
      context.commit('getAllCompanies')
    })
  },
  delCompany (context, company) {
    api.deleteCompany(company, function () {
      context.commit('getAllCompanies')
    })
  },
  addCompany (context, company) {
    return api.addCompany(company, function (data) {
      context.commit('getAllCompanies')
    })
  }
}

const mutations = {
  getAllCompanies (state, options) {
    this.dispatch('getAllCompanies', options)
  },
  setCompanies (state, companies) {
    state.all = companies
  },
  updateCompany (state, options) {
    this.dispatch('updateCompany', options)
  },
  delCompany (state, options) {
    this.dispatch('delCompany', options)
  },
  addCompany (state, options) {
    this.dispatch('addCompany', options)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/companies.js